import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GenericFormComponent } from '../generic-form/generic-form.component';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
})
export class HeroComponent implements OnInit {
  @Input() data: any;
  route: string = '';
  constructor(private router: Router, public modalService: NgbModal) {}

  ngOnInit(): void {
    this.route = this.router.url;
  }

  openModal(type: string) {
    const modalRef = this.modalService.open(GenericFormComponent, {
      size: 'lg',
      modalDialogClass: 'signup-modal',
      centered: true,
    });
    modalRef.componentInstance.type = type;
  }

  scrollDown() {
    window.scrollTo(0, 700);
  }

  redirectToApp() {
    console.log('redirect to https://app.easycode.org/');
    window.location.href = 'https://app.easycode.org/';
  }
}
